import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';
import { Link } from '@tiendanube/components';
import { PlusCircleIcon } from '@tiendanube/icons';
import { useNavegate } from 'App/hooks';
import { Responsive } from 'commons/components';
import {
  ActionsDesktop,
  HeaderContent,
  HeaderTop,
  IonPageStratus,
} from 'commons/components/IonPageStratus';
import { useIsMobileDevice } from 'domains/Auth/hooks';
import {
  DraftOrdersListDesktop,
  DraftOrdersListEmpty,
  DraftOrdersListError,
  DraftOrdersListMobile,
} from './components';
import DraftOrdersHelpLink from './components/DraftOrdersHelpLink/DraftOrdersHelpLink';
import { DraftOrdersPOSAlert } from '../../components/DraftOrdersPOSAlert';
import { useDraftOrders } from '../../hooks';

function DraftOrderList(): JSX.Element {
  const { t } = useTranslation(Domain.ORDERS);
  const { goTo } = useNavegate();
  const isMobileDevice = useIsMobileDevice();

  const { isError, fetchDraftOrders, isEmpty, isSuccess } = useDraftOrders();

  const goToNewDraftOrder = () => {
    goTo('/draft-orders/new');
  };

  const title = t('draftOrders.title');

  useEffect(() => {
    if (isEmpty && !isSuccess) {
      fetchDraftOrders();
    }
  }, [fetchDraftOrders, isEmpty, isSuccess]);

  if (isEmpty) {
    return <DraftOrdersListEmpty />;
  }

  return (
    <IonPageStratus
      width="medium"
      headerTop={
        <HeaderTop
          actions={<Link onClick={goToNewDraftOrder} icon={PlusCircleIcon} />}
        />
      }
      headerContent={
        <HeaderContent
          title={title}
          actions={
            !isEmpty && (
              <ActionsDesktop
                actions={[
                  {
                    appearance: 'primary',
                    children: t('draftOrders.addDraftOrder'),
                    icon: PlusCircleIcon,
                    onClick: goToNewDraftOrder,
                  },
                ]}
              />
            )
          }
        />
      }
      headerFixed
    >
      {!isMobileDevice && <DraftOrdersPOSAlert />}
      {isError && <DraftOrdersListError onRetryError={fetchDraftOrders} />}
      {!isEmpty && !isError && (
        <Responsive
          mobile={<DraftOrdersListMobile />}
          desktop={<DraftOrdersListDesktop />}
        />
      )}
      <DraftOrdersHelpLink />
    </IonPageStratus>
  );
}

export default DraftOrderList;
